import { RaiseText } from "../raise-components"
import React from "react"

import {
  EarthIcon,
  MoneyIcon,
  MonitorIcon,
  PayQRCodeIcon,
  RecorrentIcon,
  SecurityIcon,
} from "@atos6/icons"
import { ColLeft, ColRight, NotActiveCard } from "./Cells.styles"

export const NotActive = () => {
  return (
    <>
      <ColLeft>
        <NotActiveCard>
          <RaiseText
            fontSize="20px"
            color="#100225"
            textAlign="center"
            fontWeight="600"
            marginBottom="32px">
            Gratuito
          </RaiseText>
          <MoneyIcon />
          <RaiseText fontSize="14px" color="#595959" marginTop="50px" textAlign="center">
            O sistema A6 Pay é totalemente gratuito para instituições religiosas, se você é cliente
            Atos6 Gestão ou Prime não ahaverá nenhum custo adicional e com as melhores taxas de
            transações que vão diretamente para a conta bancária (Dentro do prazo de recebimento)
          </RaiseText>
        </NotActiveCard>
        <NotActiveCard>
          <RaiseText
            fontSize="20px"
            color="#100225"
            textAlign="center"
            fontWeight="600"
            marginBottom="32px">
            Receba ofertas de qualquer lugar do mundo
          </RaiseText>
          <EarthIcon />
          <RaiseText fontSize="14px" color="#595959" marginTop="50px" textAlign="center">
            Não deixe de receber ofertas de alguém que não está na mesma cidade que você. Com a
            Contribuição Online você expande o alcance da sua igreja para aqueles que se solidarizam
            com ela e facilita a vida dos irmãos que estão morando em um local distante.
          </RaiseText>
        </NotActiveCard>
        <NotActiveCard>
          <RaiseText
            fontSize="20px"
            color="#100225"
            textAlign="center"
            fontWeight="600"
            marginBottom="32px">
            Maior segurança e organização
          </RaiseText>
          <SecurityIcon />
          <RaiseText fontSize="14px" color="#595959" marginTop="50px" textAlign="center">
            Nada de receber dinheiro em mãos ou perder muito tempo contando e separando o dinheiro
            para cada finalidade. Com a Contribuição Online você transfere com um clique o dinheiro
            dos dízimos e ofertas para a conta bancária da igreja.
          </RaiseText>
        </NotActiveCard>
      </ColLeft>
      <ColRight>
        <NotActiveCard>
          <RaiseText
            fontSize="20px"
            color="#100225"
            textAlign="center"
            fontWeight="600"
            marginBottom="32px">
            Tenha uma página de doação exclusiva
          </RaiseText>
          <MonitorIcon />
          <RaiseText fontSize="14px" color="#595959" marginTop="50px" textAlign="center">
            Receba uma página de doação, onde sua instituição pode personalziar e receber doações em
            qualquer momento, e em qualquer lugar.
          </RaiseText>
        </NotActiveCard>
        <NotActiveCard>
          <RaiseText
            fontSize="20px"
            color="#100225"
            textAlign="center"
            fontWeight="600"
            marginBottom="32px">
            Doações recorrentes
          </RaiseText>
          <RecorrentIcon />
          <RaiseText fontSize="14px" color="#595959" marginTop="50px" textAlign="center">
            Aumente a quantidade de contribuições da sua igreja com a Contribuição Mensal. Basta o
            contribuinte selecionar quantas vezes deseja ser cobrado por aquele valor e todo mês o
            Atos6 efetuará a cobrança automaticamente. Facilidade para os dizimistas.
          </RaiseText>
        </NotActiveCard>
        <NotActiveCard>
          <RaiseText
            fontSize="20px"
            color="#100225"
            textAlign="center"
            fontWeight="600"
            marginBottom="32px">
            Use o A Pay em seu site e transmissões online (vídeo e fotos)
          </RaiseText>
          <PayQRCodeIcon />
          <RaiseText fontSize="14px" color="#595959" marginTop="50px" textAlign="center">
            Você pode incorporar o A6 online no site da instituição e tenha toda a segurança e
            comodidade dp sistema A6 Pay, além disso receba um QR Code para utilizar em suas
            transmissões online, artes e postagens
          </RaiseText>
        </NotActiveCard>
      </ColRight>
    </>
  )
}
